// CHG-123 REQ-V123-052/062: 이슈/할 일 상세에서 원본 메시지 메타 표시
import { MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SourceMessageInfo {
  messageId: string;
  isDeleted: boolean;
  createdAt: string;
  channel: {
    id: string;
    name: string | null;
    type: 'PROJECT' | 'USER' | 'DM';
    isArchived: boolean;
    projectKey?: string | null;
    project?: { projectKey: string } | null;
  } | null;
}

interface Props {
  sourceMessage: SourceMessageInfo;
}

export default function SourceMessageMeta({ sourceMessage }: Props) {
  const navigate = useNavigate();

  if (sourceMessage.isDeleted || !sourceMessage.channel) {
    return (
      <div className="flex items-center gap-1.5 text-sm text-gray-400 italic">
        <MessageSquare className="size-3.5" />
        <span>원본 메시지가 삭제되었습니다</span>
      </div>
    );
  }

  const ch = sourceMessage.channel;
  const projectKey = ch.projectKey ?? ch.project?.projectKey ?? null;
  const channelLabel = ch.name ?? (ch.type === 'DM' ? 'DM' : '채널');

  const d = new Date(sourceMessage.createdAt);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  const dateStr = `${yyyy}-${mm}-${dd} ${hh}:${mi}`;

  const handleClick = () => {
    if (ch.type === 'PROJECT' && projectKey) {
      navigate(`/projects/${projectKey}/chat?messageId=${sourceMessage.messageId}`);
    } else {
      navigate(`/chat/${ch.id}?messageId=${sourceMessage.messageId}`);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 hover:underline"
      aria-label="원본 메시지로 이동"
    >
      <MessageSquare className="size-3.5" />
      <span>채팅 메시지에서 생성됨 — {dateStr}, #{channelLabel}</span>
    </button>
  );
}
